import { BaseAsset } from './BaseAsset';
import { QuestionResponse } from './QuestionResponse';

export class QuestionAsset extends BaseAsset{
    planeColour: string;
    textColour: string;
    backgroundOpacity: number;
    text: string;
    textSize: number;
    correctMessage: string;
    incorrectMessage: string;
    score: number;
    fontFamily: string;
    hasFeedback: boolean;
    questionType: string;
    responses: QuestionResponse[];
    selectedResponseIndex: number;
    read: boolean;
    submitted: boolean;
}